import { render, staticRenderFns } from "./AppListItem.vue?vue&type=template&id=5d1baa0c&scoped=true&"
import script from "./AppListItem.vue?vue&type=script&lang=js&"
export * from "./AppListItem.vue?vue&type=script&lang=js&"
import style0 from "./AppListItem.vue?vue&type=style&index=0&id=5d1baa0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1baa0c",
  null
  
)

export default component.exports